import { useContext } from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SharedAntdTable from '../../common/shared-antd-table/SharedAntdTable';
import sharedRouterLinks from '../../components/app/shared-routes/sharedRouterLinks';
import UserContext from '../../contexts/user-context/UserProvider';
import {
  setDeleteModalOpened,
  setPackageFormOpenedAction,
  setSelectedTableRow,
  setConfirmModal
} from '../../redux/packages-slice/appPackagesSlice';
// import AppPackagesTableColumns from './AppPackagesTableColumns';
import queryString from 'query-string';
import AppPackagesTableColumns from './AppPackagesTableColumns';

const AppPackagesPageTable = () => {
  const { search } = useLocation();
  const values = queryString.parse(search);
  const { i18n } = useTranslation();
  const { user } = useContext(UserContext);
  const dispatch = useDispatch();
  const fetchedTableData = useSelector(
    (store) => store.appPackages.fetchedTableData
  );
  const fetchDataCount = useSelector(
    (store) => store.appPackages.fetchDataCount
  );
  const deleteModalOpened = useSelector(
    (store) => store.appPackages.deleteModalOpened
  );
  const isLoadingTableData = useSelector(
    (store) => store.appPackages.isLoadingTableData
  );
  // map all data to dataSource
  const [tableDataSource, setTableDataSource] = useState([]);
  const mapDataSource = (data) => {
    return data.map((obj, index) => ({
      ...obj,
      key: obj.id
    }));
  };
  useEffect(() => {
    let isMounted = true;

    if (fetchedTableData?.length >= 0) {
      const mappedData = mapDataSource(fetchedTableData);
      if (isMounted) {
        setTableDataSource(mappedData);
      }
    }

    return () => {
      isMounted = false;
    };
  }, [fetchDataCount, fetchedTableData]);

  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  const tablePagination = useSelector(
    (store) => store.appPackages.tablePagination
  );

  return (
    <SharedAntdTable
      scroll={'auto'}
      showHeader={true}
      className={`recent-clients-table ${i18n.dir()}`}
      hasPagination={true}
      tableDataSource={tableDataSource}
      tableColumns={AppPackagesTableColumns}
      allFetchedTableData={fetchedTableData}
      setFormModalOpened={() => dispatch(setPackageFormOpenedAction(true))}
      // setDetailsModalOpened={setDetailsModalOpened}
      //
      deleteModalOpened={deleteModalOpened}
      setDeleteModalOpened={(v) => dispatch(setDeleteModalOpened(v))}
      setSelectedTableRow={(v) => dispatch(setSelectedTableRow(v))}
      //
      setConfirmModal={(v) => dispatch(setConfirmModal(v))}
      isLoadingTableData={isLoadingTableData}
      user={user}
      tablePagination={tablePagination}
      baseTablePageUrl={`${sharedRouterLinks?.appPackagesRoute}?searchText=${
        values?.searchText || ''
      }&sort=${values?.sort || ''}`}
    />
  );
};

export default AppPackagesPageTable;
